import QuestionThread from './QuestionThread';

export default QuestionThread;